"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = cropLabel;

function cropLabel(crop) {
  return crop ? {
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  } : '';
}